export const isTechnicianAssignable = (tech) =>
  tech && tech.is_active !== false && tech.blacklisted !== true;

export const isTechnicianArchived = (tech) => tech?.is_active === false;
